import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

// Connects to data-controller="date-time-base"
export default class extends Controller {
  convertTo24HourFormat(timeIn12Hour) {
    const [time, modifier] = timeIn12Hour.split(" ");
    let [hours, minutes] = time.split(":");

    if (modifier === "PM" && hours !== "12") {
      hours = parseInt(hours, 10) + 12;
    } else if (modifier === "AM" && hours === "12") {
      hours = "00";
    }

    return `${hours}:${minutes}`;
  }

  findController(identifier, valueType, type = "") {
    return this.application.controllers.find((controller) => {
      const matchesIdentifier = controller.context.identifier === identifier;
      const matchesValueType = controller[valueType];
      const matchesType = type === "" || controller.typeValue === type;

      return matchesIdentifier && matchesValueType && matchesType;
    });
  }

  getEndDateInput(type = "false") {
    return this.findController("date-input", "endDateValue", type);
  }

  getStartDateInput(type = "false") {
    return this.findController("date-input", "startDateValue", type);
  }

  getEndTimeInput(type = "false") {
    return this.findController("time-input", "endTimeValue", type);
  }

  getStartTimeInput(type = "false") {
    return this.findController("time-input", "startTimeValue", type);
  }
}
